import { useState } from "react";
import api from "../api/axios";
import { toast } from "react-hot-toast";

export default function PayBills() {
  const [form, setForm] = useState({
    serviceType: "",
    provider: "",
    accountOrPhone: "",
    amount: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.serviceType || !form.provider || !form.accountOrPhone || !form.amount) {
      toast.error("Please fill in all fields");
      return;
    }

    try {
      setLoading(true);
      const res = await api.post("/payments/flutterwave/bill", form);
      const link =
        res.data?.flutterwave?.data?.authorization_url ||
        res.data?.flutterwave?.data?.link ||
        res.data?.flutterwave?.data?.meta?.authorization_url ||
        res.data?.flutterwave?.link;

      if (link) {
        window.location.href = link;
        return;
      }

      toast.success(res.data.message || "Bill payment processed");
      setForm({ serviceType: "", provider: "", accountOrPhone: "", amount: "" });
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-4xl space-y-6 text-white">
      <section className="rounded-[2rem] border border-white/10 bg-slate-900/75 p-6 backdrop-blur-xl">
      <h1 className="text-2xl font-bold mb-2">Pay Bills</h1>
      <p className="text-slate-300">
        Pay utility bills, subscriptions, and other services directly from your wallet.
      </p>
      </section>

      <form
        onSubmit={handleSubmit}
        className="space-y-4 rounded-[2rem] border border-white/10 bg-slate-900/75 p-6 backdrop-blur-xl"
      >
        <div>
          <label className="mb-1 block text-sm font-medium text-slate-300">
            Service Type
          </label>
          <select
            name="serviceType"
            value={form.serviceType}
            onChange={handleChange}
            className="w-full rounded-xl border border-white/15 bg-white/5 p-2.5 text-white"
          >
            <option value="">Select service</option>
            <option value="airtime">Airtime</option>
            <option value="data">Data</option>
            <option value="electricity">Electricity</option>
            <option value="tv">TV Subscription</option>
          </select>
        </div>

        <div>
          <label className="mb-1 block text-sm font-medium text-slate-300">
            Provider
          </label>
          <select
            name="provider"
            value={form.provider}
            onChange={handleChange}
            className="w-full rounded-xl border border-white/15 bg-white/5 p-2.5 text-white"
          >
            <option value="">Select provider</option>
            <option value="MTN">MTN</option>
            <option value="GLO">GLO</option>
            <option value="Airtel">Airtel</option>
            <option value="9mobile">9mobile</option>
            <option value="Ikeja Electric">Ikeja Electric</option>
            <option value="DSTV">DSTV</option>
          </select>
        </div>

        <div>
          <label className="mb-1 block text-sm font-medium text-slate-300">
            Account / Phone Number
          </label>
          <input
            type="text"
            name="accountOrPhone"
            value={form.accountOrPhone}
            onChange={handleChange}
            placeholder="Enter account or phone number"
            className="w-full rounded-xl border border-white/15 bg-white/5 p-2.5 text-white placeholder:text-slate-400"
          />
        </div>

        <div>
          <label className="mb-1 block text-sm font-medium text-slate-300">
            Amount (₦)
          </label>
          <input
            type="number"
            name="amount"
            value={form.amount}
            onChange={handleChange}
            placeholder="Enter amount"
            className="w-full rounded-xl border border-white/15 bg-white/5 p-2.5 text-white placeholder:text-slate-400"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-xl bg-accent px-6 py-3 font-semibold text-slate-950 transition hover:opacity-90 disabled:opacity-50"
        >
          {loading ? "Processing..." : "Pay Bill"}
        </button>
      </form>
    </div>
  );
}

